import { Observable, observe, Scope } from 'wdc-cube'
import { ResultadoDetalhado } from '../../bordero.types'

@Observable
export class DialogoResultadoScope extends Scope {
    @observe() origem = ''
    @observe() nome = ''
    @observe() documento = ''
    @observe() resultado = {} as ResultadoDetalhado

    onClose = Scope.ASYNC_ACTION
}

export default DialogoResultadoScope
